/**
 * Envío AP-11 · sube el video grabado con la cámara: el servidor recorta el
 * tramo [start, end], lo pasa a MP4 y lo registra en la Galería.
 */
import axios from 'axios';
import { toUploadError } from '../utils/uploadLimits';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function uploadCameraClip(blob, { start, end, audio = false, filename, onProgress } = {}) {
  const form = new FormData();
  form.append('file', blob, filename || 'camara.webm');
  form.append('start', String(start ?? 0));
  form.append('end', String(end));
  form.append('audio', audio ? 'true' : 'false');
  try {
    const { data } = await axios.post(`${API}/files/camera-clip`, form, {
      timeout: 180000,
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
    return data;
  } catch (err) {
    throw toUploadError(err);
  }
}

/** AP-14 · «Adaptar video»: crea un MP4 nuevo (recorte, resolución, fps, peso). */
export async function adaptVideo({ url, start, end, height = null, fps = null, maxMB = null, audio = true, name = null }) {
  try {
    const { data } = await axios.post(`${API}/files/video-adapt`, {
      url, start, end, height, fps, max_mb: maxMB, audio, name,
    }, { timeout: 300000 });
    return data;
  } catch (err) {
    throw toUploadError(err);
  }
}
